import axios from 'axios';
import authHeader from 'services/API/Auth/AuthHeader';
import authHeaderMultipart from 'services/API/Auth/AuthHeaderMultipart';

const getManAperte = () => {
    //console.log("getman aperte")
    return axios.get(axios.defaults.baseURL + '/utility/manifestazioni_aperte', { headers: authHeaderMultipart() });
}
const getAllManifestazioni = () => {
          return axios.get(axios.defaults.baseURL + '/utility/manifestazioni');

}

const getManDefault = () => {
   // console.log("getman default")
    return axios.get(axios.defaults.baseURL + '/utility/manDefault', { headers: authHeaderMultipart() });
}

const createMan = (data) => {

   // console.log(data);

    return axios.post(axios.defaults.baseURL + '/utility/manifestazione_ins', data, {headers: authHeaderMultipart()})
};

const updateMan = (nome, data) => {
 //   console.log("update= " + nome);
  //  console.log("data= " + data.pdf_regolamento);
    return axios.post(axios.defaults.baseURL + `/utility/manifestazione_upd/${nome}`, data, { headers: authHeaderMultipart() });
};


const seleziona_dettagli_man = (nome) => {

   // console.log("seleziona_dettagli= " + nome);
    return axios.get(axios.defaults.baseURL + `/utility/manifestazione_seleziona_dettagli/${nome}`, { headers: authHeader() });

}
const seleziona_file_man = (nome, tipo) => {

   // console.log("seleziona_regolamento= " + nome);
    const response = axios.get(axios.defaults.baseURL + `/utility/manifestazione_file/${nome}/${tipo}`, { headers: authHeader() }, { responseType: 'blob' },);
   // console.log(response);
    return response;
}
const getAllCodiciM = () => {
    // console.log(authHeader());
    return axios.get(axios.defaults.baseURL + `/professioni/getAllCM`);
}

const getAllSorgenti = () => {
          return axios.get(axios.defaults.baseURL + '/utility/sorgenti');

}


const getAllSpazi = () => {

    return axios.get(axios.defaults.baseURL + `/utility/getAllSpazi`, { headers: authHeader() });
}

const getAllTipologie = () => {
    return axios.get(axios.defaults.baseURL + '/utility/tipologie_espositive', { headers: authHeader() });
}
const download_file = (nome_file) => {

    // console.log("seleziona_pdf= " + nome_file);
    const response = axios.get(axios.defaults.baseURL + `/utility/downloadFile/${nome_file}`, { headers: authHeader() }, { responseType: 'blob' },);
   // console.log("RESPONSE=" + response);
    return response;
}

const getNotifiche = (ruolo,id) => {
    //la query ne tira giu 20
    return axios.get(axios.defaults.baseURL + `/utility/notifiche/${ruolo}/${id}`, { headers: authHeader() });
}
const getAllNotifiche = (ruolo,id,manifestazione) => {
    return axios.get(axios.defaults.baseURL + `/utility/all_notifiche/${ruolo}/${id}/${manifestazione}`, { headers: authHeader() });
}

const esporta_xls_notifiche=(ruolo,id,man)=>{


    //console.log(righe);

    const response= axios.get(axios.defaults.baseURL + `/utility/excel_row_notifiche/${ruolo}/${id}/${man}`,{headers: authHeader()}, {responseType: 'blob'});

    return response;

}

 const uploadModulo = (data) => {

return axios.post(axios.defaults.baseURL + '/utility/modulo_ins',data, {headers: authHeaderMultipart()
})  
};
const updateModulo = (id, data) => {
  console.log(data);

  return axios.post(axios.defaults.baseURL + `/utility/modulo_upd/${id}`, data,{headers: authHeaderMultipart()});
};
const removeModulo = (id) => {
  console.log("remove= "+id);
  return axios.post(axios.defaults.baseURL + `/utility/modulo_remove/${id}`,null,{headers: authHeader()});
};


  const downloadModulo = (idFile) => {

    
    const response = axios.get(axios.defaults.baseURL + `/utility/modulo_download/${idFile}`, { headers: authHeader() }, { responseType: 'blob' },);
   
    return response;
}


const UtilityService = {
    getManAperte, getAllManifestazioni,getManDefault,
    createMan,
    updateMan,
    getAllCodiciM,
    seleziona_dettagli_man,
    seleziona_file_man, download_file,
    getAllTipologie, getAllSpazi,getNotifiche,getAllSorgenti,
    uploadModulo, updateModulo, removeModulo,downloadModulo,getAllNotifiche,esporta_xls_notifiche
};

export default UtilityService;
